<template>
    <div class="form-item">
        <label class="label-caption">Tipo Produto</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        opcaoSelecionada: {type: String, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 'C', descricao: 'CARNES E DERIVADOS' },
                { id: 'L', descricao: 'LEITES E DEVIRADOS' },
                { id: 'M', descricao: 'PRODUTOS DE ABELHAS E DERIVADOS' },
                { id: 'O', descricao: 'OVOS E DERIVADOS' },
                { id: 'P', descricao: 'PESCADOS E DERIVADOS' },
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: '%', descricao: 'TODOS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:opcaoSelecionada', event.target.value);
        }
    }
}
</script>